import { useGetPublicBukuTamuPejabat, usePostPublicBukuTamu } from '@tatatemplate/shared-lib'

export const usePejabatDropdown = () => {
  return useGetPublicBukuTamuPejabat({
    query: {
      queryKey: ['buku-tamu', 'pejabat'],
      select: (res) => res.data,
      staleTime: 5 * 60 * 1000,
      retry: 2,
    },
  })
}

/**
 * Hook generated apa adanya — variabelnya `{ data: [...] }`, bukan array telanjang.
 */
export const useSubmitBukuTamu = usePostPublicBukuTamu
